<template>
  <!-- 线下 -->
  <Modal v-model="visible" title="详情" :width="modalWidth" :footer-hide="true" class="my-modal p-b">
    <Tabs v-model="labelName" @on-click="changeTab">
      <TabPane label="投保信息" name="1"></TabPane>
      <TabPane label="被保人及保障权益" name="2"></TabPane>
      <TabPane label="服务费信息" v-if="detailInfoFlag" name="3"></TabPane>
      <TabPane label="影像资料" v-if="showyyTab" name="4"></TabPane>
    </Tabs>
    <div class="content" ref="bodyRef">
      <loading :isShow="loading" />
      <div class="body">
        <!--------------------------------------------------------------- 基础信息 --------------------------------------------------------------------->
        <template v-if="labelName == 1">
          <!-- 基础信息--必填项 -->
          <Form ref="formInline" class="page-form detail" :model="formData" :rules="formDataValidate" :label-width="120">
            <div class="form-title">出单信息</div>
            <FormItem label="出单机构">
              <div>{{ formData.orgName | filterNull }}</div>
            </FormItem>
            <FormItem label="出单团队">
              <div>{{ formData.groupName | filterNull }}</div>
            </FormItem>
            <FormItem label="出单业务员">
              <div>{{ formData.salesmanName | filterNull }}</div>
            </FormItem>
            <FormItem label="协同人">
              <div>{{ formData.helpUserName | filterNull }}</div>
            </FormItem>
            <FormItem label="保单号">
              <div>{{ formData.policyNo | filterNull }}</div>
            </FormItem>
            <FormItem label="保险公司">
              <div>{{ formData.companyName | filterNull }}</div>
            </FormItem>
            <FormItem label="总保费(元)">
              <div>{{ formData.fee | filterNull }}</div>
            </FormItem>
            <FormItem label="区域">
              <div>{{ formData.area | filterNull }}</div>
            </FormItem>
            <FormItem label="投保日期">
              <div>{{ formData.holdTime | filterTime('YYYY-MM-DD') }}</div>
            </FormItem>
            <FormItem label="回执回销状态">
              <lzDicTxt dicType="RECEIPT_STATUS" :dicCode="formData.receiptStatus" v-if="formData.receiptStatus"></lzDicTxt>
            </FormItem>
            <FormItem label="回执回销日期">
              <div>{{ formData.receiptDate | filterTime('YYYY-MM-DD') }}</div>
            </FormItem>
            <FormItem label="回执签收日期">
              <div>{{ formData.receiptDate2 | filterTime('YYYY-MM-DD') }}</div>
            </FormItem>
            <FormItem label="回访状态">
              <lzDicTxt dicType="VERIFY_STATUS" :dicCode="formData.verifyStatus" v-if="formData.verifyStatus"></lzDicTxt>
            </FormItem>
            <FormItem label="回访日期">
              <div>{{ formData.verifyTime | filterTime('YYYY-MM-DD') }}</div>
            </FormItem>
            <FormItem label="过犹豫期日期">
              <div>{{ formData.hesitateTime | filterTime('YYYY-MM-DD') }}</div>
            </FormItem>
            <FormItem label="生效日期">
              <div>{{ formData.effectTime | filterTime('YYYY-MM-DD') }}</div>
            </FormItem>
            <FormItem label="承保日期">
              <div>{{ formData.insureTime | filterTime('YYYY-MM-DD') }}</div>
            </FormItem>
            <FormItem label="双录状态">
              <lzDicTxt dicType="DOUBLE_STATUS" :dicCode="formData.doubleRecordStatus"></lzDicTxt>
            </FormItem>
            <FormItem label="是否自保件">
              <div v-if="formData.isSelfHold == 1">是</div>
              <div v-else-if="formData.isSelfHold == 0">否</div>
              <div v-else>-</div>
            </FormItem>
            <FormItem label="是否互保件">
              <div v-if="formData.isMutualHold == 1">是</div>
              <div v-else-if="formData.isMutualHold == 0">否</div>
              <div v-else>-</div>
            </FormItem>
            <FormItem label="业务类别">
              <div v-if="formData.sellType == 1">网销</div>
              <div v-else-if="formData.sellType == 2">电销</div>
              <div v-else-if="formData.sellType == 3">经代</div>
              <div v-else>-</div>
            </FormItem>
            <FormItem label="终保日期">
              <div v-if="formData.endTime == '终身'">终身</div>
              <div v-else>{{ formData.endTime | filterTime('YYYY-MM-DD') }}</div>
            </FormItem>
            <FormItem label="支付日期">
              <div>{{ formData.payTime | filterTime('YYYY-MM-DD HH:mm') }}</div>
            </FormItem>
            <FormItem label="业务来源">
              <div v-if="formData.sellResource == 1">分销</div>
              <div v-else-if="formData.sellResource == 2">直营</div>
              <div v-else>-</div>
            </FormItem>
            <FormItem label="录单人员">
              <div>{{ formData.enterUserName | filterNull }}</div>
            </FormItem>
            <div class="form-title">产品信息</div>
            <FormItem label="主附险类型">
              <div>主险</div>
            </FormItem>
            <FormItem label="产品名称">
              <div>{{ formData.productName | filterNull }}</div>
            </FormItem>
            <FormItem label="交费方式">
              <div>{{ formData.payTypeDesc }}</div>
            </FormItem>
            <FormItem label="交费期限">
              <div>{{ formData.paymentDesc }}</div>
            </FormItem>
            <FormItem label="保障期限">
              <div v-if="formData.guaranteeType == 1">终身</div>
              <div v-else>
                <span>{{ formData.guaranteeLimit }}</span>
                <span>{{ formData.guaranteeType | filterGuaranteeType }}</span>
              </div>
            </FormItem>
            <FormItem label="保额(元)">
              <div>{{ formData.insuredAmount | filterNull }}</div>
            </FormItem>
            <FormItem label="是否含身故">
              <div v-if="formData.includingDeath == '1'">含身故</div>
              <div v-else-if="formData.includingDeath == '0'">不含身故</div>
              <div v-else>-</div>
            </FormItem>
            <FormItem label="保单年度">
              <div>{{ formData.payNumber }}</div>
            </FormItem>
            <FormItem label="保费(元)">
              <div>{{ formData.mainFee | filterNull }}</div>
            </FormItem>
            <FormItem label="保单状态">
              <div>{{ formData.status | filterStatus }}</div>
            </FormItem>
            <FormItem label="退保原因" v-if="formData.status == '-1'">
              <div>{{ formData.reason | filterNull }}</div>
            </FormItem>
            <FormItem label="退保日期" v-if="formData.status == '-1'">
              <div>{{ formData.returnTime | filterTime('YYYY-MM-DD') }}</div>
            </FormItem>
          </Form>
        </template>
        <!--------------------------------------------------------------- 附加险 --------------------------------------------------------------------->
        <template v-if="labelName == 1">
          <div class="form-title" v-if="hasAddition">附加险</div>
          <template v-if="hasAddition">
            <Form :ref="`additionalForm${m}`" class="page-form detail"
              :class="{ 'bottom-25-border': formDynamic.additional.length > 1 }" :rules="additionRules" :model="form"
              v-for="(form, m) in formDynamic.additional" :key="m + 11" :label-width="120">
              <FormItem label="产品名称">
                <div>{{ form.productName | filterNull }}</div>
              </FormItem>
              <FormItem label="保费(元)">
                <div>{{ form.fee | filterNull }}</div>
              </FormItem>
              <FormItem label="保单状态">
                <div>{{ form.status | filterStatus }}</div>
              </FormItem>
              <FormItem label="交费方式">
                <div>{{ form.payTypeDesc }}</div>
              </FormItem>
              <FormItem label="交费期限">
                <div>{{ form.paymentDesc }}</div>
              </FormItem>
              <FormItem label="保障期限">
                <div v-if="form.guaranteeType == 1">终身</div>
                <div v-else>
                  <span>{{ form.guaranteeLimit }}</span>
                  <span>{{ form.guaranteeType | filterGuaranteeType }}</span>
                </div>
              </FormItem>
              <FormItem label="保单年度">
                <div>{{ form.payNumber }}</div>
              </FormItem>
              <FormItem label="保额(元)">
                <div>{{ form.insuredAmount | filterNull }}</div>
              </FormItem>
            </Form>
          </template>
        </template>
        <!--------------------------------------------------------------- 投保人信息 --------------------------------------------------------------------->
        <template v-if="labelName == 1">
          <div class="form-title">投保人信息</div>
          <Form ref="policyHoderref" class="page-form detail" :model="policyHoderForm" :rules="policyHoderValidate"
            :label-width="120">
            <FormItem label="投保人姓名">
              <div>{{ policyHoderForm.holderName | filterNull }}</div>
            </FormItem>
            <FormItem label="投保人证件类型" :label-width="130">
              <div>{{ policyHoderForm.holderIdType | filterCardType }}</div>
            </FormItem>
            <FormItem label="投保人证件号" :label-width="130">
              <div>
                <span v-if="!policyHoderForm.eyeShow1">{{policyHoderForm.holderIdNo|filterNull}}</span>
                <span v-else>{{policyHoderForm.holderIdNo1|filterNull}}</span>
                <span v-if="policyHoderForm.holderIdNo">
                  <i class="iconfont iconxianshi eye-icon" v-if="policyHoderForm.eyeShow1" @click="openEye(policyHoderForm,'eyeShow1','holderIdNo')"></i>
                  <i class="iconfont iconyincang eye-icon" v-else @click="openEye(policyHoderForm,'eyeShow1','holderIdNo')"></i>
                </span>
              </div>
            </FormItem>
            <FormItem label="投保人性别">
              <div>{{ policyHoderForm.holderSex | filterSex }}</div>
            </FormItem>
            <FormItem label="投保人出生日期" :label-width="130">
              <div>{{ policyHoderForm.holderBirth | filterTime('YYYY-MM-DD') }}</div>
            </FormItem>
            <FormItem label="投保人年收入(万元)" :label-width="130">
              <div>{{ policyHoderForm.holderIncome | filterNull }}</div>
            </FormItem>
            <FormItem label="投保人电话">
              <div>
                <span v-if="!policyHoderForm.eyeShow">{{policyHoderForm.holderMobile|filterNull}}</span>
                <span v-else>{{policyHoderForm.holderMobile1|filterNull}}</span>
                <span v-if="policyHoderForm.holderMobile">
                  <i class="iconfont iconxianshi eye-icon" v-if="policyHoderForm.eyeShow" @click="openEye(policyHoderForm,'eyeShow','holderMobile')"></i>
                  <i class="iconfont iconyincang eye-icon" v-else @click="openEye(policyHoderForm,'eyeShow','holderMobile')"></i>
                </span>
              </div>
            </FormItem>
            <FormItem label="投保人邮箱" :label-width="130">
              <div>
                <span v-if="!policyHoderForm.eyeShow3">{{policyHoderForm.holderEmail|filterNull}}</span>
                <span v-else>{{policyHoderForm.holderEmail1|filterNull}}</span>
                <span v-if="policyHoderForm.holderEmail">
                  <i class="iconfont iconxianshi eye-icon" v-if="policyHoderForm.eyeShow3" @click="openEye(policyHoderForm,'eyeShow3','holderEmail')"></i>
                  <i class="iconfont iconyincang eye-icon" v-else @click="openEye(policyHoderForm,'eyeShow3','holderEmail')"></i>
                </span>
              </div>
            </FormItem>
            <FormItem label="投保人职业" :label-width="130">
              <div>{{ policyHoderForm.holderJob | filterNull }}</div>
            </FormItem>
            <FormItem label="身高(cm)">
              <div>{{ policyHoderForm.height | filterNull }}</div>
            </FormItem>
            <FormItem label="体重(kg)" :label-width="130">
              <div>{{ policyHoderForm.weight | filterNull }}</div>
            </FormItem>
            <FormItem label="有无社保" :label-width="130">
              <div v-if="formData.hasSocialInsurance == 1">有</div>
              <div v-else-if="formData.hasSocialInsurance == 0">无</div>
              <div v-else>-</div>
            </FormItem>
            <FormItem label="联系地址">
              <div>{{ policyHoderForm.region | filterNull }}</div>
            </FormItem>
            <FormItem label="投保人详细地址" style="width:66.6%">
              <div>
                <span v-if="!policyHoderForm.eyeShow2">{{policyHoderForm.holderAddress|filterNull}}</span>
                <span v-else>{{policyHoderForm.holderAddress1|filterNull}}</span>
                <span v-if="policyHoderForm.holderAddress">
                  <i class="iconfont iconxianshi eye-icon" v-if="policyHoderForm.eyeShow2" @click="openEye(policyHoderForm,'eyeShow2','holderIdNo')"></i>
                  <i class="iconfont iconyincang eye-icon" v-else @click="openEye(policyHoderForm,'eyeShow2','holderAddress')"></i>
                </span>
              </div>
            </FormItem>
            <FormItem label="家庭关系">
              <lzDicTxt dicType="MARITAL_STATUS" :dicCode="formData.familyRelationShip"></lzDicTxt>
            </FormItem>
            <FormItem label="投保人证件有效期" style="width:33.3%" :label-width="130">
              <div v-if="policyHoderForm.lifelong">长期有效</div>
              <div v-else-if="policyHoderForm.holderIdStartDate && policyHoderForm.term">
                {{ policyHoderForm.holderIdStartDate | filterTime('YYYY-MM-DD') }}至{{ policyHoderForm.term | filterTime('YYYY-MM-DD') }}
              </div>
              <div v-else>-</div>
            </FormItem>
          </Form>
        </template>
        <!--------------------------------------------------------------- 被保险人信息 --------------------------------------------------------------------->
        <template v-if="labelName == 2">
          <div class="form-title">被保人信息</div>
          <div class="insuredForm-wrap" v-for="(insureds, ins) in insuredFormDynamic.insuredForm" :key="`${ins}`">
            <div class="triangle-topleft" v-show="insuredFormDynamic.insuredForm.length > 1">
              <span>{{ ins + 1 }}</span>
            </div>
            <Form :ref="`insuredFormRef${ins}`" class="page-form insuredBg detail" :key="`insuredFormRef${ins}`"
              :rules="insuredFormValidate" :model="insureds" :label-width="130">
              <FormItem label="被保人姓名">
                <div>{{ insureds.name | filterNull }}</div>
              </FormItem>
              <FormItem label="被保人证件类型">
                <div>{{ insureds.idType | filterCardType }}</div>
              </FormItem>
              <FormItem label="被保人证件号">
                <div>
                  <span v-if="!insureds.eyeShow1">{{insureds.idNo|filterNull}}</span>
                  <span v-else>{{insureds.idNo1|filterNull}}</span>
                  <span v-if="insureds.idNo">
                    <i class="iconfont iconxianshi eye-icon" v-if="insureds.eyeShow1" @click="openEye(insureds,'eyeShow1','idNo',ins,2)"></i>
                    <i class="iconfont iconyincang eye-icon" v-else @click="openEye(insureds,'eyeShow1','idNo',ins,2)"></i>
                  </span>
                </div>
              </FormItem>
              <FormItem label="被保人性别">
                <div>{{ insureds.sex | filterSex }}</div>
              </FormItem>
              <FormItem label="与投保人的关系">
                <div>{{ insureds.holderRelation | filterRelationShip }}</div>
              </FormItem>
              <FormItem label="被保人年收入(万元)">
                <div>{{ insureds.income | filterNull }}</div>
              </FormItem>
              <FormItem label="被保人电话">
                <div>
                  <span v-if="!insureds.eyeShow2">{{insureds.mobile|filterNull}}</span>
                  <span v-else>{{insureds.mobile1|filterNull}}</span>
                  <span v-if="insureds.mobile">
                    <i class="iconfont iconxianshi eye-icon" v-if="insureds.eyeShow2" @click="openEye(insureds,'eyeShow2','mobile',ins,2)"></i>
                    <i class="iconfont iconyincang eye-icon" v-else @click="openEye(insureds,'eyeShow2','mobile',ins,2)"></i>
                  </span>
                </div>
              </FormItem>
              <FormItem label="被保人出生日期">
                <div>{{ insureds.birth | filterTime('YYYY-MM-DD') }}</div>
              </FormItem>
              <FormItem label="被保人职业">
                <div>{{ insureds.job | filterNull }}</div>
              </FormItem>
              <FormItem label="被保人邮箱">
                <div>
                  <span v-if="!insureds.eyeShow3">{{insureds.email|filterNull}}</span>
                  <span v-else>{{insureds.email1|filterNull}}</span>
                  <span v-if="insureds.email">
                    <i class="iconfont iconxianshi eye-icon" v-if="insureds.eyeShow3" @click="openEye(insureds,'eyeShow3','email',ins,2)"></i>
                    <i class="iconfont iconyincang eye-icon" v-else @click="openEye(insureds,'eyeShow3','email',ins,2)"></i>
                  </span>
                </div>
              </FormItem>
              <FormItem label="身高(cm)">
                <div>{{ insureds.height | filterNull }}</div>
              </FormItem>
              <FormItem label="体重(kg)">
                <div>{{ insureds.weight | filterNull }}</div>
              </FormItem>
              <FormItem label="有无社保">
                <div v-if="insureds.hasSocialInsurance == 1">有</div>
                <div v-else-if="insureds.hasSocialInsurance == 0">无</div>
                <div v-else>-</div>
              </FormItem>
              <FormItem label="家庭关系">
                <lzDicTxt dicType="MARITAL_STATUS" :dicCode="insureds.familyRelationShip"></lzDicTxt>
              </FormItem>
              <FormItem label="联系地址">
                <div>{{ insureds.region | filterNull }}</div>
              </FormItem>
              <FormItem label="被保人证件有效期" class="certy-vali1">
                <div v-if="insureds.term">{{ insureds.term | filterTime('YYYY-MM-DD') }}</div>
                <div v-else>{{ insureds.lifelong ? '终身' : '-' }}</div>
              </FormItem>
              <FormItem label="被保人详细地址" class="two">
                <div>
                  <span v-if="!insureds.eyeShow4">{{insureds.address|filterNull}}</span>
                  <span v-else>{{insureds.address1|filterNull}}</span>
                  <span v-if="insureds.address">
                    <i class="iconfont iconxianshi eye-icon" v-if="insureds.eyeShow4" @click="openEye(insureds,'eyeShow4','address',ins,2)"></i>
                    <i class="iconfont iconyincang eye-icon" v-else @click="openEye(insureds,'eyeShow4','address',ins,2)"></i>
                  </span>
                </div>
              </FormItem>
              <Form :rules="rightsValidate" :model="right" v-for="(right, r) in insureds.rights1" :key="`rightsRef${r}`"
                :label-width="130">
                <FormItem label="权益名称">
                  <div>{{ right.name | filterNull }}</div>
                </FormItem>
                <FormItem label="保障额度">
                  <div>{{ right.quota | filterNull }}</div>
                </FormItem>
                <FormItem label="保障内容" class="two">
                  <div>{{ right.content | filterNull }}</div>
                </FormItem>
              </Form>
            </Form>
          </div>
        </template>
        <!--------------------------------------------------------------- 受益人信息 --------------------------------------------------------------------->
        <template v-if="labelName == 2">
          <div class="form-title">受益人信息</div>
          <div v-if="benefitFormDynamic.benefitForm.length">
            <Form :ref="`benefitFormRef${b}`" class="page-form detail"
              :class="{ 'bottom-25-border': benefitFormDynamic.benefitForm.length > 1 }" :rules="benefitValidate"
              :model="benefit" v-for="(benefit, b) in benefitFormDynamic.benefitForm" :key="b + ' '" :label-width="130">
              <FormItem label="受益人类型" prop="beneficiaryType" v-if="b == 0">
                <div v-if="beneficiaryType == 2">指定受益人</div>
                <div v-else-if="beneficiaryType == 1">法定受益人</div>
              </FormItem>
              <FormItem label="受益人姓名" prop="name" v-if="beneficiaryType == 2">
                <div>{{ benefit.name | filterNull }}</div>
              </FormItem>
              <FormItem label="与被保人的关系" prop="insuranceRelation" v-if="beneficiaryType == 2">
                <div>{{ benefit.insuranceRelation | filterRelationShip }}</div>
              </FormItem>
              <FormItem label="受益人证件类型" prop="idType" v-if="beneficiaryType == 2">
                <div>{{ benefit.idType | filterCardType }}</div>
              </FormItem>
              <FormItem label="受益人证件号" prop="idNo" v-if="beneficiaryType == 2">
                <div>
                  <span v-if="!benefit.eyeShow1">{{benefit.idNo|filterNull}}</span>
                  <span v-else>{{benefit.idNo1|filterNull}}</span>
                  <span v-if="benefit.idNo">
                    <i class="iconfont iconxianshi eye-icon" v-if="benefit.eyeShow1" @click="openEye(benefit,'eyeShow1','idNo',b,3)"></i>
                    <i class="iconfont iconyincang eye-icon" v-else @click="openEye(benefit,'eyeShow1','idNo',b,3)"></i>
                  </span>
                </div>
              </FormItem>
              <FormItem label="受益人性别" prop="sex" v-if="beneficiaryType == 2">
                <div>{{ benefit.sex | filterSex }}</div>
              </FormItem>
              <FormItem label="受益人出生日期" v-if="beneficiaryType == 2">
                <div>{{ benefit.birth | filterTime('YYYY-MM-DD') }}</div>
              </FormItem>
              <FormItem label="受益比例(%)" prop="benefitScale" v-if="beneficiaryType == 2">
                <div>{{ benefit.benefitScale | filterNull }}</div>
              </FormItem>
              <FormItem label="受益顺序" prop="benefitOrder" v-if="beneficiaryType == 2">
                <div>{{ benefit.benefitOrder | filterNull }}</div>
              </FormItem>
            </Form>
          </div>
          <div v-else>
            <div v-if="beneficiaryType == 2">指定受益人</div>
            <div v-else-if="beneficiaryType == 1">法定受益人</div>
          </div>

        </template>
        <!--------------------------------------------------------------- 账户信息 --------------------------------------------------------------------->
        <template v-if="labelName == 1">
          <div class="form-title">账户信息</div>
          <Form ref="accountFormRef" class="page-form detail" :model="accountForm" :label-width="130">
            <FormItem label="银行卡户名" prop="cardNoName">
              <div>{{ accountForm.cardNoName | filterNull }}</div>
            </FormItem>
            <FormItem label="银行账户" prop="account">
              <div>{{ accountForm.account | filterNull }}</div>
            </FormItem>
            <FormItem label="开户行" prop="bank">
              <div>{{ accountForm.bank | filterNull }}</div>
            </FormItem>
          </Form>
        </template>
        <!--------------------------------------------------------------- 影像资料 --------------------------------------------------------------------->
        <template v-if="labelName == 4">
          <template v-if="insuranceContractList && insuranceContractList.length > 0">
            <div class="form-title">保险合同</div>
            <upload :imgArr="insuranceContractList" :detailFlag="true" style="margin-bottom:15px;"
              @handleSuccess="handleSuccess"></upload>
          </template>
          <template v-if="insuranceInfoList && insuranceInfoList.length > 0">
            <div class="form-title">投保资料</div>
            <upload :imgArr="insuranceInfoList" :detailFlag="true" style="margin-bottom:15px;"
              @handleSuccess="handleSuccess"></upload>
          </template>
          <template v-if="customerNoticeList && customerNoticeList.length > 0">
            <div class="form-title">客户告知书</div>
            <upload :imgArr="customerNoticeList" :detailFlag="true" style="margin-bottom:15px;"
              @handleSuccess="handleSuccess"></upload>
          </template>
          <template v-if="otherInfoList && otherInfoList.length > 0">
            <div class="form-title">其他</div>
            <upload :imgArr="otherInfoList" :detailFlag="true" @handleSuccess="handleSuccess"></upload>
          </template>
        </template>
        <!-- 服务费信息 -->
        <template v-if="labelName == 3">
          <!-- <serveInfo :obj="detailInfo" /> -->
          <serveInfoNew :obj="detailInfo" />
        </template>
      </div>
    </div>
  </Modal>
</template>
<script>
import upload from './upload'
import serveInfoNew from './serveInfoNew';
// import serveInfo from "./serveInfo";
import { editData } from '../form/editMixin'
import lzDicTxt from "@/components/commons/lzDicTxt";
import {common} from "@/api/mixins";
export default {
  mixins: [editData,common],
  data() {
    return {
      id: '',
      visible: false,
      policyNo: '',
      labelName: '1',
      detailInfo: {
        commissionInfoVOList: [],
        commissionYearNum: null,
        payType: null
      },
      showyyTab: false,// 是否显示影音tab
      modalWidth: '1350'
    }
  },
  components: {
    lzDicTxt,
    upload,
    // serveInfo,
    serveInfoNew
  },
  watch: {
    // "formData.orgId":{
    //   // 根据出单机构查询业务员
    //   handler(){
    //     this.$http({
    //       url: "/buz/userBase/getOrgUser",
    //       type: "GET",
    //       data: {
    //         orgId: this.formData.orgId,
    //       },
    //     }).then((res) => {
    //       this.salesmanList = res.data;
    //       // 回显时存在业务员名称显示对应手机号
    //       this.salesmanList.map((item, index) => {
    //         if (item.salesmanId == this.formData.salesmanId) {
    //           this.$set(this.formData,'phoneNum',item.salesmanMobile)
    //         }
    //       })
    //     })
    //   },
    // }
  },
  computed: {
    detailInfoFlag() {
      if (this.detailInfo.commissionInfoVOList && this.detailInfo.commissionInfoVOList.length > 0) {
        if (this.detailInfo.commissionInfoVOList && this.detailInfo.commissionInfoVOList[0].commissionInfoList.length > 0) {
          return true
        } else {
          return false
        }

      } else {
        return false
      }
    }
  },
  methods: {
    openEye(item,keyName,name,index,type){
      let operationType,otherInfo
      if(index>=0){
        otherInfo={
          type:type,
          index:index
        }
      }else{
        otherInfo={
          type:1
        }
      }
      if(name == 'holderMobile' || name == 'mobile'){
        operationType=2
      }else if(name == 'holderIdNo' || name =='idNo'){
        operationType=1
      }else if(name =='holderAddress' || name == 'address'){
        operationType = 5
      }else if(name == 'holderEmail' || name == 'email'){
        operationType = 4
      }
      if(!item[keyName]){
        this.descrypt({
          query:item.orderNo,
          operationFunction:15,
          operationType:operationType,
          otherInfo:otherInfo
        },item,name+'1','order_30_10').then(()=>{
          this.$set(item, keyName, true);
        })
      }else{
        this.$set(item, keyName, false);
      }
    },
    open(data = {}, type) {
      this.type = type;
      this.labelName = '1'
      this.id = data.id
      this.policyNo = data.policyNo
      this.$refs.bodyRef.scrollTop = 0
      this.getPolicyDetail()
    },
    changeTab(val) {
      this.labelName = val
      // 滚动到页面顶部
      this.$refs.bodyRef.scrollTop = 0
    },
    // 保单详情
    getPolicyDetail() {
      this.$notice.showLoading();
      this.$http({
        url: '/buz/offlinePolicy/mechan/detailEnterPolicy',
        type: 'get',
        data: {
          policyNo: this.policyNo,
        },
      })
        .then((res) => {
          this.visible = true
          this.$notice.hideLoading();
          let commissionInfoVoList = res.data.commissionInfoVoList
          // 服务费信息
          this.$set(this.detailInfo, "commissionInfoVOList", commissionInfoVoList)
          this.$set(this.detailInfo, "payType", res.data.payType)
          this.$set(this.detailInfo, "sourceType", res.data.sourceType)
          this.$set(this.detailInfo, "isDynamicRate", res.data.isDynamicRate)
          this.$set(this.detailInfo, "commissionYearNum", res.data.commissionYearNum)

          let productList = JSON.parse(JSON.stringify(res.data.productList))
          //基础信息
          const formData = JSON.parse(JSON.stringify(res.data))
          formData.productName = productList[0].productName;
          formData.fee = productList[0].fee;// 总保费(元)
          formData.mainFee = productList[0].mainFee;// 保费(元)
          formData.insuredAmount = productList[0].insuredAmount;// 保额
          formData.status = productList[0].status;// 保单状态
          formData.includingDeath = productList[0].includingDeath;// 是否含身故
          formData.payType = productList[0].payType;// 交费方式
          formData.payLimit = productList[0].payLimit;// 交费期限数字
          formData.payment = this.numberToString(productList[0].payment);// 交费期限单位
          formData.guaranteeLimit = productList[0].guaranteeLimit;// 保障期限
          formData.guaranteeType = productList[0].guaranteeType;// 保障期限时间单位
          formData.doubleRecordStatus = this.numberToString(res.data.doubleRecordStatus);// 双录状态
          formData.payNumber = productList[0].payNumber;// 保单年度
          this.formData = formData;
          // 设置详情弹窗宽度
          if((!formData.isActivityRate&&formData.isDynamicRate) || (!formData.isDynamicRate&&formData.isActivityRate)) {
            this.modalWidth = '1230';
          }else if (!formData.isDynamicRate&&!formData.isActivityRate) {
            this.modalWidth = '1130';
          }  
          //附加险
          if (productList.length > 1) {
            productList.shift()
            this.formDynamic.additional = productList
            this.hasAddition = true
          } else {
            // 无附加险不显示附加险信息
            this.hasAddition = false
          }

          //投保人
          this.policyHoderForm = res.data;
          this.policyHoderForm.term = res.data.holderValidPeriod == '终身' ? '' : res.data.holderValidPeriod // 有效期
          this.policyHoderForm.lifelong = res.data.holderValidPeriod == '终身' ? true : false // 终身
          // 被保险人
          this.insuredFormDynamic.insuredForm = res.data.insuranceList
          this.insuredFormDynamic.insuredForm.map((item) => {
            if (item.validPeriod == '终身') {
              item.term = ''
              item.lifelong = true
            } else {
              item.term = item.validPeriod
              item.lifelong = false
            }
            // 权益信息处理
            if (item.rights) {
              item.rights1 = JSON.parse(item.rights)
            }
          })
          // 受益人
          this.beneficiaryType = res.data.beneficiaryType
          if (res.data.beneficiaryList && res.data.beneficiaryList.length > 0) {
            this.benefitFormDynamic.benefitForm = res.data.beneficiaryList
          }
          //开户行
          this.accountForm = {
            bank: res.data.bank || '', //开户行
            cardNoName: res.data.cardNoName || '', //户名
            account: res.data.cardNo || '', //银行账户
          }
          if (res.data.insuranceInfoList.length > 0 || res.data.insuranceContractList.length > 0 || res.data.customerNoticeList.length > 0 || res.data.otherInfoList.length > 0) {
            this.showyyTab = true
          } else {
            this.showyyTab = false
          }
          // 影像资料回显处理
          this.insuranceInfoList = []
          this.insuranceContractList = []
          this.customerNoticeList = []
          this.otherInfoList = []
          const map = new Map([
            [this.insuranceInfoList, res.data.insuranceInfoList],
            [
              this.insuranceContractList,
              res.data.insuranceContractList,
            ],
            [this.customerNoticeList, res.data.customerNoticeList],
            [this.otherInfoList, res.data.otherInfoList],
          ])
          for (let [key, value] of map) {
            if (value) {
              value.forEach((item) => {
                const isImage = this.isImage(item)
                if (isImage) {
                  key.push({
                    url: item,
                    type: 'image',
                    show: false,
                  })
                } else {
                  key.push({
                    url: item,
                    type: 'pdf',
                    show: false,
                  })
                }
              })
            }
          }
        })
        .catch((e) => {
          console.log(e);
          this.$notice.hideLoading();
        })
    },
    // 是否是图片
    isImage(url) {
      return /\.(png|jpg|jpeg)$/.test(url.toLowerCase())
    },
    handleSuccess(res, file) {
      if (res.httpCode == 1) {
        res.data.map((item, index) => {
          let url = item.path
          let isImage = this.isImage(url)
          let type = isImage ? 'image' : 'pdf'
          this[this.uploadList].push({
            url,
            type,
            show: false,
          })
        })
      }
    },
    numberToString(data) {
      return data ? data.toString() : '';
    },
  },
  filters: {
    filterNull(val) {
      if (!val) {
        return '-'
      }
      return val
    },
    filterStatus(val) {
      if (!val) {
        return '-'
      }
      if (val == '1') {
        return '已承保'
      } else if (val == '0') {
        return "已终止"
      } else if (val == '-1') {
        return '已退保'
      }
    },
    filterGuaranteeType(val) {
      if (!val) {
        return ''
      }
      switch (val) {
        case '1':
          return '终身'
        case '2':
          return '周岁'
        case '3':
          return '年'
        case '4':
          return '月'
        case '5':
          return '天'
      }
    },
    filterVerifyStatus(val) {
      if (!val) {
        return '-'
      }
      switch (val) {
        case '0':
          return '等待回访'
        case '1':
          return '回访成功'
        case '2':
          return '回访失败'
        case '3':
          return '无需回访'
      }
    },
    filterSex(val) {
      if (!val) {
        return '-'
      }
      switch (val) {
        case '1':
          return '男'
        case '2':
          return '女'
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.my-modal .ivu-modal-body .content {
  max-height: calc(85vh - 120px);
  overflow-y: scroll;
  background: #fff;

  .body {
    padding-right: 10px;

    .page-form {
      padding-top: 0 !important;
    }

    .insuredBg {
      background: #F7F7F7;
      padding-top: 25px;
      margin-bottom: 15px;
      position: relative;
    }

    .bottom-25-border {
      border-bottom: 1px dotted #e9e9e9;
      margin-bottom: 25px;
    }

    .form-title {
      width: 100%;
      margin-bottom: 10px;
      margin-top: 10px;
      font-size: 14px;
      color: #3C464F;
      font-weight: bold;
      position: relative;
      display: flex;
      align-items: center;
      white-space: nowrap;
      height: 20px;

      &::before {
        content: "";
        display: block;
        width: 3px;
        height: 14px;
        background-color: #236DFF;
        margin-right: 6px;
      }

      &::after {
        content: "";
        display: block;
        background-color: #EFF3FC;
        height: 1px;
        width: 100%;
        margin-left: 10px;
      }
    }

    .nav-second-tab {
      margin-top: 10px;
      border-bottom: 1px solid #ececec;

      .tab-body {
        width: 40%;
        text-align: center;
        display: flex;

        span {
          flex: 1;
          font-size: 16px;
          font-family: PingFangSC-Regular;
          color: #666666;
          line-height: 40px;
          display: inline-block;
          cursor: pointer;
        }

        .active {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 600;
          border-bottom: 3px solid #236dff;
          color: #236dff;
        }
      }
    }

    .insuredForm-wrap {
      position: relative;

      .page-form {
        padding-top: 10px !important;
        padding-bottom: 5px;
      }

      .triangle-topleft {
        display: inline-block;
        border-top: 40px solid #236dff;
        border-right: 40px solid transparent;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;

        span {
          position: absolute;
          padding: 10px 0;
          left: 5px;
          top: -51px;
          text-align: center;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #FFFFFF;
        }
      }
    }
  }
}</style>
  